export const MOCK_MEDICAL_DOCUMENTS = {
  creditsLeft: 2,
  files: [
    { link: 'https://example.com/mock-1.jpg', created: new Date().toISOString(), filename: 'mock-1.jpg' },
    {
      link: 'https://example.com/mock-2.jpg',
      created: new Date(Date.now() - 3600_000).toISOString(),
      filename: 'mock-2.jpg',
    },
  ],
};
